export type AuthDomainEnv = 'development' | 'production'

const SATELLITE_PROD_HOSTS = new Set(['christspiracy.com', 'www.christspiracy.com'])
const SATELLITE_DEV_HOSTS = new Set(['localhost:3001', '127.0.0.1:3001'])

export function isSatelliteHost(host: string, env: AuthDomainEnv = 'production'): boolean {
  if (!host) return false
  if (SATELLITE_PROD_HOSTS.has(host)) return true
  if (env === 'development' && SATELLITE_DEV_HOSTS.has(host)) return true
  return false
}

export function getHostFromUrlString(url: string): string | null {
  try {
    return new URL(url).host
  } catch {
    return null
  }
}
